import React, { ReactNode } from 'react';
import Footer from '../../layouts/footer';
import Header from '../../layouts/header';
import {
  Box,
  Container,
  ContainerProps,
  useMediaQuery,
  useTheme
} from '@mui/material';

interface Props extends ContainerProps {
  children: ReactNode;
}

const Page: React.FC<Props> = ({ children, ...props }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Container sx={{ flex: 1 }} {...props}>
        <Box mt={2} mb={2} px={matches ? 2 : 0}>
          {children}
        </Box>
      </Container>
      <Footer />
    </Box>
  );
};

export default Page;
